import { render } from "./PledgesList.vue?vue&type=template&id=2aefd100&scoped=true"
import script from "./PledgesList.vue?vue&type=script&lang=js"
export * from "./PledgesList.vue?vue&type=script&lang=js"

import "./PledgesList.vue?vue&type=style&index=0&id=2aefd100&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aefd100"]])

export default __exports__